import { render, staticRenderFns } from "./CardBallsBoounce.vue?vue&type=template&id=90adb1d4&"
import script from "./CardBallsBoounce.vue?vue&type=script&lang=js&"
export * from "./CardBallsBoounce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports